import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { changeFloaterFrame } from "../redux/creators/fabricCreators";
import { FLOATER_FRAME } from "../../../constants/productOptions";

const getImage = (optionsUtility, value) => {
  if (
    optionsUtility.collectionName == "single-canvas-featured-products" &&
    value.sku == "CP-OPT-MTL_EASEL-0000-001"
  )
    return value.image2;
  else return value.image;
};

export default function ImageOptionSelect({
  option,
  optionsUtility,
  value,
  isab,
}) {
  const dispatch = useDispatch();
  const handleImageChange = () => {
    optionsUtility.changeOptionToLabel(option.name, value.label, value.sku);

    /**
     * If frame is selected and the frame canvas exists on the page,
     * add it. The check for the canvas element catches the case where
     * a user changes the frame from the cart modal
     */
    const frameDiv = document.getElementById("frame");
    if (option.handle === FLOATER_FRAME && frameDiv) {
      dispatch(changeFloaterFrame(value));
    }
  };

  if (isab)
    return (
      <Container
        isab={isab}
        selected={value.selected}
        onClick={handleImageChange}
      >
        {value.selected && (
          <span className="check">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#EB0067" />
              <path
                d="M5.14258 9.32145L7.71401 11.8929L13.1783 6.42859"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
          </span>
        )}

        <ImageAB
          src={
            getImage(optionsUtility, value) ||
            "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/none.png"
          }
          alt={value.label}
        />
      </Container>
    );

  return (
    <Container
      isab={isab}
      selected={value.selected}
      onClick={handleImageChange}
    >
      <ImageContainer>
        <Image
          src={
            getImage(optionsUtility, value) ||
            "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/none.png"
          }
          alt={value.label}
        />
      </ImageContainer>
    </Container>
  );
}
const Image = styled.img`
  object-fit: cover;
  width: 47px;
  height: 47px;
  display: inline-block;
`;

const ImageAB = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 8px;
`;

const ImageContainer = styled.div`
  width: 48px;
  height: 48px;
  padding: 1px;
  box-sizing: border-box;
`;
const Container = styled.div`
  border: ${(props) =>
    props.selected ? "1px solid var(--color-wine)" : "none"};
  cursor: pointer;
  border-radius: ${(props) => (props.isab ? "8px" : "0px")};
  border-width: ${(props) => (props.isab ? "2px" : "1px")};
  position: relative;

  .check {
    position: absolute;
    right: -10px;
    top: -10px;
  }
`;
